const sitecore = (function() {

    const prevCodes = [];

    this.filterCodes = function(code) {
      return code.getAttribute('chrometype') == 'placeholder';
    };

    this.init = () => {

      if(!window.Sitecore) {
        return;
      }
      this.prevCodes = Array.from(document.getElementsByTagName('code')).filter(this.filterCodes);
    };

    this.load = (codes) => {

      if(!codes || !window.Sitecore) {
        return;
      }

      codes = codes.filter(this.filterCodes);

      codes.forEach(el => {

        const hasKey = el.getAttribute('key');
        if(hasKey) {
          return;
        }

        this.prevCodes.forEach(prevCode => {
          const prevKey = prevCode.getAttribute('key');
          if(prevCode.getAttribute('id') == el.getAttribute('id') && prevKey) {
            el.setAttribute('key', prevKey);
          }
        });
      });
    };

    return this;

});

export default new sitecore();



// WEBPACK FOOTER //
// ../shared/sitecore/index.js